/*
 *  Product waitlist notify
 *
 *
 *  Version:
 *    1.0.0 - 2020/09/03
 */
import { backInStockForm } from '../../objects/product/BackInStock';

const WAITLIST_SUBMIT_BUTTON = '[data-waitlist-notify-submit]';
const SUBMIT_MESSAGE_DEFAULT_SELECTOR = '[data-notify-message-default]';
const SUBMIT_MESSAGE_SUCCESS_SELECTOR = '[data-notify-message-success]';
const SUBMIT_ERROR_SELECTOR = '[data-notify-error]';
const WAITLIST_SELECTOR = '[data-waitlist-notify-wrapper]';

const onButtonSubmitWaitlistNotify = (e) => {
  e.preventDefault(); // Prevent the form from submitting via the browser
  var form = $(e.currentTarget).closest('form');
  let formWrapper = $(e.currentTarget).closest(WAITLIST_SELECTOR);

  backInStockForm(form, formWrapper, SUBMIT_MESSAGE_DEFAULT_SELECTOR, 
    SUBMIT_MESSAGE_SUCCESS_SELECTOR, SUBMIT_ERROR_SELECTOR);
}

$(document).ready(() => {
    $(document).on('click touchend', WAITLIST_SUBMIT_BUTTON, (e) => onButtonSubmitWaitlistNotify(e));
});
